<template>
  <main>
    <div class="row student barfiltre">
      <div class="col-md-12">
        <TopTemplate>
          <template #left-element>
            <h3>{{ $t("title.listPeriodExam") }}</h3>
          </template>

          <template #right-element>
            <router-link :to="{name: 'addPeriodExam'}" class="btn button btn-primary" :disabled="loading">
              <i class="icon-Add" />
              {{ $t("button.addPeriodExam") }}
            </router-link>
          </template>
        </TopTemplate>
        <div class="search-date-wrapper search-filter-wrapper" :class="showFil === false ? 'borderNan' : ''">
          <div class="col-md-11 search searchStudent">
            <input v-model="params.q" type="text" placeholder="Recherche" name="search" @input="searshLevelPeriod()" />
            <img src="../../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
          </div>

          <div class="date-wrapper filter-wrapper" @click="showFilter()">
            <span>{{ $t("barFiltre.filtre") }}</span>
          </div>
        </div>
        <div v-if="showFil" class="row container-select container-filter container-note">
          <div class="search-criter">
            <p>Critères de recherche :</p>
          </div>
          <div class="col-md-4 select-wrapper">
            <v-select
              class="style-chooser"
              placeholder="Année Scolaire"
              v-model="selectedScolar"
              :searchable="true"
              :options="schoolyear"
              label="name"
              :reduce="(option) => option.id"
              @update:modelValue="ChangeScolarYear($event)"
            >
              <template #no-options="{search, searching, loading}">
                {{ $t("info.noResult") }}
              </template>
            </v-select>
          </div>
          <div class="col-md-4 select-wrapper">
            <v-select
              class="style-chooser"
              placeholder="Niveau Scolaire"
              v-model="selectedLevel"
              :searchable="true"
              :options="classes"
              label="name"
              :reduce="(option) => option.id"
              @update:modelValue="ChangeClass($event)"
            >
              <template #no-options="{search, searching, loading}"> {{ $t("info.noResult") }}</template>
            </v-select>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="container-fluid empty-message">
      <div class="col-md-12">
        <div v-if="!loading && periods.length === 0" class="card mt-4">
          <div class="col-12 empty-result text-center pt-3">
            <p>{{ $t("common.emptySearchPeriod") }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="table list_eleve">
      <div class>
        <div class="row">
          <div class="col-md-12">
            <div class="table__wrapper table-responsive-vertical table-responsive">
              <table class="table table-responsive">
                <thead>
                  <tr>
                    <th class="eleve">
                      {{ $t("periodexam.header.scolaryear") }}
                      <div class="icon-wrapper" @click="sortB('school_session_id')">
                        <i class="ri-arrow-up-s-line" :class="[specTri('school_session_id', true)]" />
                        <i class="ri-arrow-down-s-line" :class="[specTri('school_session_id', false)]" />
                      </div>
                    </th>
                    <th>{{ $t("periodexam.header.level") }}</th>
                    <th>
                      {{ $t("periodexam.header.periods") }}
                    </th>
                    <th>{{ $t("periodexam.header.exam") }}</th>
                    <th class="col-xl-2 col-md-2 text-center">
                      {{ $t("common.actions") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="period in periods" :key="period.id">
                    <td>
                      <div>
                        {{ period.school_year }}
                      </div>
                    </td>
                    <td class="col-md-2">
                      <div>{{ targetName(period.type).toString() }}</div>
                    </td>

                    <td class="col-md-2">
                      {{ period.period }}
                    </td>
                    <td class="col-md-2">
                      {{ targetExam(period.exam).toString() }}
                    </td>
                    <td class="text-center">
                      <div class="espace_height">
                        <router-link
                          :to="{
                            name: 'EditStudent',
                            params: {id: period.period_id},
                          }"
                          class
                        >
                          <i class="icon-edit-02">
                            <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                          </i>
                        </router-link>
                        <i class="icon-trash" @click.prevent="deletePeriod(period.period_id)">
                          <span class="tooltiptext">{{ $t("button.tooltip.delete") }}</span>
                        </i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="row modal_dis">
                <div class="col-md-12">
                  <div class="table__wrapper__pagination-wrapper">
                    <div class="pagination">
                      <pagination v-if="last_page > 1" :data-set="pagination" @goToPage="getResults" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../../components/toptemplate/TopTemplate.vue";
import NoteService from "../../../services/periods.service";
import pagination from "../../../components/navigation/Pagination";
import vSelect from "vue-select";
import moment from "moment";
import "@vuepic/vue-datepicker/dist/main.css";
import _ from "lodash";
export default {
  name: "ExamperiodList",
  components: {
    TopTemplate,
    pagination,
    "v-select": vSelect,
  },
  data() {
    return {
      loading: false,
      pagination: {},
      total: 0,
      classes: [],
      schoolyear: [],
      datea: null,
      readInput: true,
      showFil: false,
      params: {
        q: "",
        limit: 15,
        page: 1,
        sort: "",
        order: false,
        class_type_id: [],
        class_school_id: [],
        birthday: null,
        datede: null,
        selectedStatus: null,
      },
      status: [
        {
          id: 1,
          value: "registred",
          name: "Enregistré",
        },
        {
          id: 2,
          value: "not_registred",
          name: "Non enregistré",
        },
      ],
      last_page: null,
      selectedScolar: null,
      selectedLevel: null,
      periods: [],
      selected: [],
      moment: null,
      existStudent: false,
      selectedStatus: null,
    };
  },
  computed: {
    userModules() {
      return this.$store.state?.auth?.user?.modules;
    },
  },
  created() {
    this.moment = moment;
  },
  mounted() {
    this.FilterScolar();
    this.ListeScolar();
    this.moduleUser();
  },
  methods: {
    targetName(arrayType) {
      let NamesLeve = [];
      arrayType.forEach((val) => {
        NamesLeve.push(val.name);
      });
      return NamesLeve;
    },
    targetExam(arrayType) {
      let ArrayExam = [];
      arrayType.forEach((val) => {
        ArrayExam.push(val.name);
      });
      return ArrayExam;
    },

    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
    ChangeStatus(e) {
      this.params.selectedStatus = e ? e.name : null;
      this.selectedStatus = e ? e.value : null;
      this.getResults();
      this.params.hasfilter = true;
    },
    resetFilter() {
      this.selectedScolar = null;
      this.params.class_type_id = [];
      this.selectedLevel = null;
      this.params.class_school_id = [];
      this.params.selectedStatus = null;
      this.selectedStatus = null;
      this.params.datede = null;
      this.FilterScolar();
      this.getResults();
    },

    checkIfElementNameIsEleves() {
      return this.userModules.some((element) => element.name === this.$t("modules.student"));
    },
    moduleUser() {
      this.existStudent = this.checkIfElementNameIsEleves();
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.ListeScolar();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListeScolar();
    },
    showFilter() {
      this.showFil = !this.showFil;
    },
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    deletePeriod(id) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      //const index = this.periods.findIndex(items => items.id === id);
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteStudent"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.studentDeleted"), "", "success");
            NoteService.delete(id).then(
              () => {
                this.periods = [];
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );

            //window.location.href = '/eleves';
            //this.goBack();
            //this.$router.push('/eleves')
          }
        });
    },
    deleteSelected() {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteSelectedStudent"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.studentSelectedDeleted"), "", "success");
            NoteService.deleteAll({
              params: {
                studentsId: this.selected,
              },
            }).then(
              () => {
                this.periods = [];
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );
          }
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    ChangeScolarYear(e) {
      this.FilterScolar();
      this.getResults();
    },
    ChangeClass(e) {
      this.getResults();
    },
    handleInput() {
      this.readInput = false;
      if (this.params.datede != null) {
        this.params.datede = this.dateTime(this.params.datede);
      }
      this.getResults();
    },
    FilterScolar() {
      NoteService.getFilter({
        params: {
          school_session_id: this.selectedScolar,
        },
      }).then(
        (response) => {
          this.selectedLevel = null;
          this.schoolyear = response.data.school_year;
          this.classes = response.data.class_type;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    ListeScolar() {
      this.loading = true;
      NoteService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          sort: this.params.sort,
          order: this.params.order,
          school_session:this.selectedScolar,
          type_id:this.selectedLevel
        },
      })
        .then((response) => {
          this.periods = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.last_page = response.data.meta.last_page;
          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getResults(page = null) {
      this.selected = [];
      this.params.page = !page ? this.params.page : page;
      this.loading = true;
      NoteService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          school_session:this.selectedScolar,
          type_id:this.selectedLevel
        },
      }).then(
        (response) => {
          this.periods = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    searshLevelPeriod: _.debounce(function () {
      if (this.params.q.toString().length > 1 || !this.params.q.toString().length) {
        this.params.hasfilter = true;
        this.ListeScolar();
      }
    }, 200),
  },
};
</script>
<style scoped>
.search-filter-wrapper {
  border-bottom: 1px solid #e0e7ed;
}

.container-note {
  margin-top: 0;
}

.search-criter {
  font-size: 11px;
  color: #000;
}
</style>
